<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Nueva adenda</v-toolbar-title>
    </v-toolbar>
    <v-card class="spacing-top">
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field v-model="title" label="Descripción (opcional)"></v-text-field>
          </v-flex>
          <v-flex xs2 pr-2>
            <v-radio-group v-model="extend" label="¿Es prórroga de contrato?" column row>
              <v-radio label="Sí" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs3 pr-1>
            <DatePickerForm v-if="extend" v-model="endDate" label="Nueva fecha fin" :error-messages="endDateErrors"></DatePickerForm>
          </v-flex>
          <v-flex>
            <AttachFile ref="fileInput" @upload="uploadFiles" description single-file></AttachFile>
          </v-flex>
        </v-layout>
        <v-divider class="my-2"></v-divider>
        <ConfirmationDialog :function-yes="bindingFunction" ref="confirm" title="Abandonar página"
                            text="Se perderán los cambios del formulario actual, ¿desea continuar?"></ConfirmationDialog>
        <v-card-actions>
          <v-btn color="grey" :disabled="saving" @click="goBackConfirmation">Volver</v-btn>
          <v-spacer></v-spacer>
          <p class="red--text mr-3" v-for="error in fileErrors" :key="error">{{ error }}</p>
          <a :href="asset.url" target="_blank" v-if="asset && !files.length" class="mr-2">Adjunto actual</a>
          <v-btn @click="openFileDirectory" color="primary" :disabled="saving">
            <span v-if="isEditing">Cambiar adjunto</span>
            <span v-else>Agregar adjunto</span>
          </v-btn>
          <v-btn @click="uploadAllFiles" color="primary" :disabled="saving">Enviar</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { requiredIf } from 'vuelidate/lib/validators'
import moment from 'moment'
import DatePickerForm from '../../../common/ui/DatePickerForm'
import AttachFile from '../../../common/ui/AttachFile'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'

export default {
  mixins: [validationMixin, s3UploadMixin, createEntityMixin],

  validations () {
    return {
      files: { required: requiredIf(() => { return !this.isEditing }) },
      endDate: { required: requiredIf(() => { return this.extend }) }
    }
  },

  components: {
    DatePickerForm,
    AttachFile,
    ConfirmationDialog
  },

  data () {
    return {
      title: '',
      endDate: null,
      asset: null,
      extend: false,
      contractEndDate: moment(this.$route.params.contractEndDate, 'DD/MM/YYYY').format('YYYY-MM-DD').toString(),
      createPath: 'addendum/new',
      editPath: `addendum/${this.$route.params.idAddendum}`
    }
  },

  computed: {
    isEditing () {
      return this.$route.params.hasOwnProperty('idAddendum')
    },
    fileErrors () {
      return this.getRequiredErrors('files', 'Adjunto requerido.')
    },
    endDateErrors () {
      let errors = this.getRequiredErrors('endDate')
      if (this.$v['endDate'].$dirty && this.extend && !this.isValidEndDate()) {
        errors.push('La fecha de fin debe ser posterior a la fecha de fin de contrato')
      }
      return errors
    }
  },

  methods: {
    getPayload () {
      return {
        'contract': this.$route.params.id,
        'title': this.title,
        'asset': this.assets,
        'end_date': this.endDate
      }
    },
    setData (data) {
      this.title = data.title
      this.endDate = this.formatDate(data.endDate)
      this.asset = data.asset
      if (this.$route.params.hasOwnProperty('extend')) {
        if (this.$route.params.extend !== null) {
          this.extend = true
          this.inputDate(this.$route.params.extend)
        }
      }
    },
    isValidEndDate () {
      if (this.extend) {
        if (this.endDate === null) {
          return false
        } else {
          return this.endDate > this.contractEndDate
        }
      } else {
        return true
      }
    },
    isValidForm () {
      return !this.$v.$invalid && this.isValidEndDate()
    }
  }
}
</script>

<style scoped>
.spacing-top {
  margin-top: 6em !important;
}
</style>
